var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Right_arrow","data-name":"Right arrow","d":"M6089.951,1779.292l16.735-18-16.735-18-1.265,1.361,15.47,16.639-15.47,16.639Z","transform":"translate(-6088.687 -1743.293)","fill":"#333"}));
}

ArrowRight.defaultProps = {"width":"18","height":"35.999","viewBox":"0 0 18 35.999"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
